/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Stat_ValueInputs */

const vi_shop_home_stat_value = /** @type {(inputs: Shop_Home_Stat_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số liệu`)
};

/**

* @param {Shop_Home_Stat_ValueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_stat_value = /** @type {((inputs?: Shop_Home_Stat_ValueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Stat_ValueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_stat_value(inputs)
});